webpackJsonp([183400410456155],{

/***/ 135:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageDescription = function (_React$Component) {
	  _inherits(PageDescription, _React$Component);
	
	  function PageDescription() {
	    _classCallCheck(this, PageDescription);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PageDescription.prototype.render = function render() {
	    var text = this.props.text;
	
	    if (text) {
	      return _react2.default.createElement(
	        "h2",
	        { className: "page-description" },
	        text
	      );
	    }
	    return null;
	  };
	
	  return PageDescription;
	}(_react2.default.Component);
	
	exports.default = PageDescription;
	module.exports = exports["default"];

/***/ }),

/***/ 136:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageTitle = function (_React$Component) {
	  _inherits(PageTitle, _React$Component);
	
	  function PageTitle() {
	    _classCallCheck(this, PageTitle);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PageTitle.prototype.render = function render() {
	    var text = this.props.text;
	
	    if (text) {
	      return _react2.default.createElement(
	        "h1",
	        { className: "page-title" },
	        text
	      );
	    }
	    return null;
	  };
	
	  return PageTitle;
	}(_react2.default.Component);
	
	exports.default = PageTitle;
	module.exports = exports["default"];

/***/ }),

/***/ 137:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PaginationLink = __webpack_require__(104);
	
	var _PaginationLink2 = _interopRequireDefault(_PaginationLink);
	
	__webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pagination = function (_React$Component) {
	  _inherits(Pagination, _React$Component);
	
	  function Pagination() {
	    _classCallCheck(this, Pagination);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        page = _props.page,
	        pages = _props.pages,
	        prev = _props.prev,
	        next = _props.next;
	
	    return _react2.default.createElement(
	      "nav",
	      { className: "pagination" },
	      _react2.default.createElement(_PaginationLink2.default, {
	        className: "newer-posts",
	        url: prev,
	        text: "\u2190 Newer Posts"
	      }),
	      _react2.default.createElement(
	        "span",
	        { className: "page-number" },
	        "Page ",
	        page,
	        " of ",
	        pages
	      ),
	      _react2.default.createElement(_PaginationLink2.default, {
	        className: "older-posts",
	        url: next,
	        text: "Older Posts \u2192"
	      })
	    );
	  };
	
	  return Pagination;
	}(_react2.default.Component);
	
	exports.default = Pagination;
	module.exports = exports["default"];

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(138);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaginationLink = function (_React$Component) {
	  _inherits(PaginationLink, _React$Component);
	
	  function PaginationLink() {
	    _classCallCheck(this, PaginationLink);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PaginationLink.prototype.render = function render() {
	    if (this.props.url) {
	      var className = "nav-link";
	      if (this.props.className) {
	        className = className + " " + this.props.className;
	      }
	
	      // Clone this.props and then delete Component specific
	      // props so we can spread the rest into the img.
	
	      var rest = _objectWithoutProperties(this.props, []);
	
	      delete rest.style;
	      delete rest.className;
	      delete rest.text;
	      delete rest.url;
	
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        _extends({ to: this.props.url }, rest, { className: className }),
	        this.props.text
	      );
	    }
	    return null;
	  };
	
	  return PaginationLink;
	}(_react2.default.Component);
	
	exports.default = PaginationLink;
	module.exports = exports["default"];

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(10);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainContent = function (_React$Component) {
	  _inherits(MainContent, _React$Component);
	
	  function MainContent() {
	    _classCallCheck(this, MainContent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  MainContent.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    var classes = (0, _classnames2.default)("content", this.props.className);
	
	    return _react2.default.createElement(
	      "main",
	      { id: "content", className: classes, role: "main" },
	      children
	    );
	  };
	
	  return MainContent;
	}(_react2.default.Component);
	
	exports.default = MainContent;
	module.exports = exports["default"];

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MainContent = __webpack_require__(52);
	
	var _MainContent2 = _interopRequireDefault(_MainContent);
	
	var _Pagination = __webpack_require__(103);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	__webpack_require__(141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaginatedContent = function (_React$Component) {
	  _inherits(PaginatedContent, _React$Component);
	
	  function PaginatedContent() {
	    _classCallCheck(this, PaginatedContent);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PaginatedContent.prototype.render = function render() {
	    var _props = this.props,
	        page = _props.page,
	        pages = _props.pages,
	        prev = _props.prev,
	        next = _props.next,
	        children = _props.children;
	
	    var className = "";
	    if (page > 1) {
	      className = className + " paged";
	    }
	    return _react2.default.createElement(
	      _MainContent2.default,
	      { className: className },
	      _react2.default.createElement(
	        "div",
	        { className: "extra-pagination inner" },
	        _react2.default.createElement(_Pagination2.default, { page: page, pages: pages, prev: prev, next: next })
	      ),
	      children,
	      _react2.default.createElement(_Pagination2.default, { page: page, pages: pages, prev: prev, next: next })
	    );
	  };
	
	  return PaginatedContent;
	}(_react2.default.Component);
	
	exports.default = PaginatedContent;
	module.exports = exports["default"];

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PostListing = __webpack_require__(73);
	
	var _PostListing2 = _interopRequireDefault(_PostListing);
	
	var _SiteConfig = __webpack_require__(16);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Drawer = __webpack_require__(74);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Navigation = __webpack_require__(72);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _SiteWrapper = __webpack_require__(77);
	
	var _SiteWrapper2 = _interopRequireDefault(_SiteWrapper);
	
	var _MainHeader = __webpack_require__(75);
	
	var _MainHeader2 = _interopRequireDefault(_MainHeader);
	
	var _MainNav = __webpack_require__(76);
	
	var _MainNav2 = _interopRequireDefault(_MainNav);
	
	var _BlogLogo = __webpack_require__(69);
	
	var _BlogLogo2 = _interopRequireDefault(_BlogLogo);
	
	var _MenuButton = __webpack_require__(71);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _PageTitle = __webpack_require__(102);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	var _PageDescription = __webpack_require__(101);
	
	var _PageDescription2 = _interopRequireDefault(_PageDescription);
	
	var _Footer = __webpack_require__(70);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _PaginatedContent = __webpack_require__(108);
	
	var _PaginatedContent2 = _interopRequireDefault(_PaginatedContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagTemplate = function (_React$Component) {
	  _inherits(TagTemplate, _React$Component);
	
	  function TagTemplate() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TagTemplate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      menuOpen: false
	    }, _this.handleOnClick = function (evt) {
	      evt.stopPropagation();
	      if (_this.state.menuOpen) {
	        _this.closeMenu();
	      } else {
	        _this.openMenu();
	      }
	    }, _this.handleOnClose = function (evt) {
	      evt.stopPropagation();
	      _this.closeMenu();
	    }, _this.openMenu = function () {
	      _this.setState({ menuOpen: true });
	    }, _this.closeMenu = function () {
	      _this.setState({ menuOpen: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TagTemplate.prototype.render = function render() {
	    var _props$pathContext = this.props.pathContext,
	        tag = _props$pathContext.tag,
	        nodes = _props$pathContext.nodes,
	        page = _props$pathContext.page,
	        pages = _props$pathContext.pages,
	        total = _props$pathContext.total,
	        limit = _props$pathContext.limit,
	        prev = _props$pathContext.prev,
	        next = _props$pathContext.next;
	
	    var authorsEdges = this.props.data.authors.edges;
	    return _react2.default.createElement(
	      _Drawer2.default,
	      { isOpen: this.state.menuOpen },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Posts tagged as \"" + tag + "\" | " + _SiteConfig2.default.siteTitle }),
	      _react2.default.createElement(_Navigation2.default, { config: _SiteConfig2.default, onClose: this.handleOnClose }),
	      _react2.default.createElement(
	        _SiteWrapper2.default,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "tag-template" },
	          _react2.default.createElement(
	            _MainHeader2.default,
	            { className: "tag-head", cover: tag.featureImage },
	            _react2.default.createElement(
	              _MainNav2.default,
	              null,
	              _react2.default.createElement(_BlogLogo2.default, { logo: _SiteConfig2.default.siteLogo, title: _SiteConfig2.default.siteTitle }),
	              _react2.default.createElement(_MenuButton2.default, {
	                navigation: _SiteConfig2.default.siteNavigation,
	                onClick: this.handleOnClick
	              })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "vertical" },
	              _react2.default.createElement(
	                "div",
	                { className: "main-header-content inner" },
	                _react2.default.createElement(_PageTitle2.default, { text: tag }),
	                _react2.default.createElement(_PageDescription2.default, {
	                  text: tag.description || "A " + total + "-post collection"
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _PaginatedContent2.default,
	            {
	              page: page,
	              pages: pages,
	              total: total,
	              limit: limit,
	              prev: prev,
	              next: next
	            },
	            _react2.default.createElement(_PostListing2.default, { postEdges: nodes, postAuthors: authorsEdges })
	          )
	        ),
	        _react2.default.createElement(_Footer2.default, {
	          copyright: _SiteConfig2.default.copyright,
	          promoteGatsby: _SiteConfig2.default.promoteGatsby
	        })
	      )
	    );
	  };
	
	  return TagTemplate;
	}(_react2.default.Component);
	
	/* eslint no-undef: "off" */
	
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	
	exports.default = TagTemplate;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tag-jsx-20e23471da3d1e948797.js